import { useFormContext } from 'react-hook-form';
import type { TariffFormValues } from 'widgets/project-creation-stepper/model';
import { useSession } from '@/app/_providers/session-provider';
import { useEffect, useMemo } from 'react';
import { FormControlTextField } from 'shared/ui/form-elements';
import FormControlWithLabel from 'shared/ui/form-control-with-label';
import { TariffSelector } from '@/enteties/tariff';
import { useServiceType } from 'widgets/project-creation-stepper/providers/service-provider';
import { Alert, AlertDescription } from 'shared/ui/alert';
import { Info } from 'lucide-react';
import * as m from '@paraglide/messages';
const MAX_SUMMARY_LENGTH = 27;
export const TariffComponent = () => {
  const {
    control,
    formState,
    watch,
    setValue
  } = useFormContext<TariffFormValues>();
  const session = useSession();
  const {
    serviceType
  } = useServiceType();
  const {
    errors
  } = formState;
  // @ts-ignore
  const tariffId: string = watch('tariffId');
  useEffect(() => {
    setValue('tariffId', '5', {
      shouldDirty: true
    });
  }, [serviceType, setValue]);
  const maxLength = useMemo(() => MAX_SUMMARY_LENGTH - (session?.user.name.length ?? 0), [session?.user.name.length]);
  return <div className="grid gap-4" data-sentry-component="TariffComponent" data-sentry-source-file="tariff-component.tsx">
      <div className="grid gap-2">
        <FormControlTextField rules={{
        pattern: {
          value: /^[\sa-z0-9а-яА-я-]+$/i,
          message: m.create_dialog_step_tariff_projectName_symbolErrors()
        },
        required: m.required_field(),
        maxLength: {
          value: maxLength,
          message: m.create_dialog_step_tariff_projectName_lengthError({
            maxLength
          })
        },
        validate: {
          noNewWord: value => !/new/i.test(value) || m.create_dialog_step_tariff_projectName_noNew()
        }
      }} placeholder={m.create_dialog_step_tariff_projectName_placeholder()} className="w-full" name="name" control={control} label={m.create_dialog_step_tariff_projectName()} error={errors.name} data-sentry-element="FormControlTextField" data-sentry-source-file="tariff-component.tsx" />
      </div>
      <div className="grid gap-2">
        <div className="space-y-3">
          {(tariffId === '1' || tariffId === '4') && <Alert size="sm" variant="warning">
              <Info className="size-5 p-0.5" />
              <AlertDescription>
                {m.create_dialog_step_tariff_plan_alert()}
              </AlertDescription>
            </Alert>}
          <FormControlWithLabel text={m.create_dialog_step_tariff_plan()} data-sentry-element="FormControlWithLabel" data-sentry-source-file="tariff-component.tsx">
            <TariffSelector name="tariffId" control={control} serviceType={serviceType!} data-sentry-element="TariffSelector" data-sentry-source-file="tariff-component.tsx" />
          </FormControlWithLabel>
        </div>
      </div>
    </div>;
};